/* jshint esversion: 6, -W097 */
/* globals module */

UtilitySelectorCookieService.$inject = ['$rootScope', 'CookiesService', 'UtilService'];
function UtilitySelectorCookieService($rootScope, CookiesService, UtilService) {

    var USER_UTILITY_COOKIE = 'user-utility-data';
    var _pub = {};

    /**
     * Set a user's utility selection in a cookie.
     * @param utility
     */
    _pub.setElectricalUtility = function (utilityData) {
        CookiesService.set(USER_UTILITY_COOKIE, utilityData);
        $rootScope.$broadcast('utilitySet', utilityData);
    };

    /**
     * Get user's utility from a cookie.
     * @returns {*} deserialized `utility` obj
     */
    _pub.getElectricalUtility = function () {
        var utility = CookiesService.get(USER_UTILITY_COOKIE);
        return utility ? JSON.parse(utility) : utility;
    };

    /**
     * Get the user's chosen zip code, if one was chosen.
     * @returns {*}
     */
    _pub.getUserZipCode = function () {
        var userZipCode = null;
        var utility = _pub.getElectricalUtility();

        if (utility && 'postal_code' in utility) {
            userZipCode = parseInt(utility.postal_code);
        }
        return userZipCode;
    };

    /**
     * Get the user electrical utility rate or custom set rate.
     * @returns {*} returns a float or null
     */
    _pub.getElectricalUtilityRate = function () {
        var electricalRate = null;
        var utility = _pub.getElectricalUtility();
        if (utility) {
            if (utility.residential_rate) {
                electricalRate = utility.residential_rate;
            } else if (utility.electricalRate) {
                electricalRate = utility.electricalRate;
            } else if (utility.electrical_rate) {
                electricalRate = utility.electrical_rate;
            } else if (utility.user_set_electrical_rate) {
                electricalRate = utility.user_set_electrical_rate;
            }
            electricalRate = parseFloat(electricalRate);
        }
        return electricalRate;
    };


    /**
     * Gets the user's electrical utility id.
     * @returns {*} returns an int or null
     */
    _pub.getElectricalUtilityId = function () {
        var utilityId = null;
        var utility = _pub.getElectricalUtility();

        if (utility) {
            if (utility.electrical_utility_id) {
                utilityId = utility.electrical_utility_id;
            }
        }
        return utilityId;
    };

    /**
     * Function determines if a utility has been set.
     * @returns {boolean}
     */
    _pub.isElectricalUtilitySet = function () {
        var cookie_value = CookiesService.get(USER_UTILITY_COOKIE);
        if (cookie_value === "null") {
            return false;
        }
        return Boolean(CookiesService.get(USER_UTILITY_COOKIE));
    };

    /**
     * If the utility rate picker is enabled, get the user's selected utility. Otherwise, get the utility id
     * for the current site, then return it as an int.
     *
     * @returns {number|Number} - The current utility id
     */
    _pub.getUtilityId = function () {
        var utilityId = null;
        if (UtilService.isFeatureEnabled('utility_rate_selector') || UtilService.isFeatureEnabled('utility_state_rate_selector')) {
            utilityId = _pub.getElectricalUtilityId();
        } else {
            var utilities = UtilService.getSiteSetting('utility_include_list');

            if (utilities && utilities.length > 0) {
                utilityId = utilities[0]
            }
        }
        if (utilityId) {
            return parseInt(utilityId);
        }
    };

    return _pub;
}

module.exports = UtilitySelectorCookieService;